export const config = {
  endpoints: {
    getOrders: '/rest/V1/mit-api/ask-product/orders',
    sendMessage: '/rest/V1/mit/contact-rep',
    saveContactRepMethod: '/rest/V1/mit-api/ask-product/save',
    getRepresentatives: '/en/reps/assigned/index',
  },
};

export const FEATURE_FLAG_NAME = 'MB20F-4351-APQ-V2';
export const TRACKING_EVENT_NAME = 'ask-a-product-question';
export const SLIDE_DOWN_ANIMATION_MS = 2500;
export const LAST_ORDER_DATE_NO_LATER_THAN = new Date(2023, 9, 9).getTime();
